import { render } from "./policy-association-modal.vue?vue&type=template&id=b85306ea&scoped=true"
import script from "./policy-association-modal.vue?vue&type=script&lang=js"
export * from "./policy-association-modal.vue?vue&type=script&lang=js"

import "./policy-association-modal.vue?vue&type=style&index=0&id=b85306ea&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b85306ea"]])

export default __exports__